import React from 'react';
import { Shield, Network, Settings, Search, Activity, Lock, AlertTriangle, CheckCircle } from 'lucide-react';
import { networkServices, cybersecurityServices } from '../data/mock';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const iconMap = {
  shield: Shield,
  network: Network,
  settings: Settings,
  search: Search,
  activity: Activity,
  lock: Lock,
  'alert-triangle': AlertTriangle,
  'check-circle': CheckCircle
};

const Services = () => {
  const renderServiceCards = (services) => {
    return services.map((service) => {
      const IconComponent = iconMap[service.icon];
      return (
        <Card key={service.id} className="service-card">
          <CardHeader className="service-card-header">
            <div className="service-header-row">
              <div className="service-icon">
                <IconComponent size={24} />
              </div>
              <CardTitle className="service-title">{service.title}</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="service-card-content">
            <CardDescription className="service-description">
              {service.description}
            </CardDescription>
          </CardContent>
        </Card>
      );
    });
  };

  return (
    <section id="services" className="services-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Our Consultancy Services</h2>
          <p className="section-description">
            <span className="brand-name">1stHand Consultancy</span> bridges Business Success with Network Infrastructure and Cybersecurity Excellence
          </p>
        </div>
        
        <div className="services-category">
          <h3 className="category-title category-title-bold">Network Consultancy Services</h3>
          <p className="category-description">
            Empowering your business with robust network infrastructure that drives operational efficiency and growth
          </p>
          <div className="services-grid">
            {renderServiceCards(networkServices)}
          </div>
        </div>

        <div className="services-category cybersecurity-section">
          <h3 className="category-title cybersecurity-title category-title-bold">Cybersecurity Consultancy Services</h3>
          <p className="category-description">
            Protecting your business assets with comprehensive security strategies that enable confident digital transformation
          </p>
          <div className="services-grid">
            {renderServiceCards(cybersecurityServices)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;